import { useEffect, useState } from "react";
import { getOwnMembership } from "../../../api/teamMemberApi";
import { getOrganization } from "../../../api/organizationApi";

interface UseTeamLeadOptions {
  userId: string | null;
}

/**
 * Custom hook to get the leadUid of the caller's own team.
 * @returns The leadUid of the team, or null if not found
 */
export function useTeamLead({ userId }: UseTeamLeadOptions) {
  const [leadUid, setLeadUid] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getTeamLead = async () => {
      setIsLoading(true);
      if (!userId) {
        setLeadUid(null);
        setIsLoading(false);
        return;
      }

      try {
        const membership = await getOwnMembership();
        if (!membership?.organizationId) {
          setLeadUid(null);
          setIsLoading(false);
          return;
        }

        const org = await getOrganization(membership.organizationId);
        setLeadUid(org?.leadUid || null);
      } catch (error) {
        console.error("❌ Error getting team lead:", error);
        setLeadUid(null);
      } finally {
        setIsLoading(false);
      }
    };

    getTeamLead();
  }, [userId]);

  return { leadUid, isLoadingLeadUid: isLoading };
}
